import React from "react";
import { Box, keyframes, useColorModeValue } from "@chakra-ui/react";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
`;

export default function TradingSpinner({ size = "40px" }) {
  const trackColor = useColorModeValue("gray.200", "gray.600");
  const arcStart = useColorModeValue("#3182CE", "#90CAF9");
  const arcEnd = useColorModeValue("#38A169", "#68D391");

  return (
    <Box
      w={size}
      h={size}
      borderRadius="full"
      border="3px solid"
      borderColor={trackColor}
      borderTopColor={arcStart}
      borderRightColor={arcEnd}
      animation={`${spin} 0.8s linear infinite, ${pulse} 1.6s ease-in-out infinite`}
    />
  );
}
